module.exports = __webpack_public_path__ + "static/media/company-profile-preview-logo-app.fd067722.png";